/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { API_URL, APIV,API_VERSION_V2 } from '../../src/config/constant';
import secureStorage from '../config/encrypt';
// import { toast } from 'react-toastify';
import * as HELPER from "../config/helper";
 
const Axios = axios.create();
Axios.interceptors.response.use(
    (response) => {  
        if(response && response.headers && response.headers["isresponseencrypted"] && +response.headers["isresponseencrypted"] == 1){
            let iv = response.headers['responseiv'];
            let symmetricKey = response.headers['responseaeskey'];   
            response.data = HELPER.decryptResponseData(response.data?.encryptedData,iv,symmetricKey);
            // debugger; 
            
        }
        return response;
    },
    (error) => {

        // handle error
        if (error.response) {
            if (+error.response.status === 503) {
            } else if (+error.response.status === 401) {
                secureStorage.removeItem('authUserInfo');
                window.location.href = '/login';
            } else if (+error.response.status === 400) {
            }

        }

        return error.response;
    });

// (window as any).commonErrorToast = function (error: any) {
//     if (typeof error == "string") toast.error(error);
//     else if (error.message) toast.error("Helllo", error.message);
// }
const MasterSerive = {

    getToken() {
        return (secureStorage.getItem('authUserInfo') && secureStorage.getItem('authUserInfo')['token'])
            ? secureStorage.getItem('authUserInfo')['token']
            : ''
    },
    delete(URL: string, body: object, headers: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        return Axios.delete(`${API_URL.GETWAY_API}${URL}`, { data: body, headers })
    },
    post: async(URL: string, body?: object, headers?: any) => { 
        let isEncryptionOn = secureStorage.getItem('is_encryption_on');
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterSerive.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2
   
        headers['Isresponseencrypted'] = 1;
        
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        // let encryptedData: any = {body, headers}
        let encryptedData: any = (isEncryptionOn && URL.indexOf("getPublicKey") === -1 && URL.indexOf("bulkUpload/uploadSoaCsv") === -1) ? await HELPER.encryptRequestData(URL, headers, body) : {body, headers}   
        return Axios.post(`${API_URL.GETWAY_API}${URL}`, encryptedData?.body, { headers: encryptedData.headers })
    },
    put(URL: string, body?: object, headers?: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        return Axios.put(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    get: async(URL: string, query?: any, headers?: any) => {
        let isEncryptionOn = secureStorage.getItem('is_encryption_on');
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterSerive.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2 

        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;

        // let encryptedData: any = {body: query, headers}
        let encryptedData: any = (isEncryptionOn && URL.indexOf("getPublicKey") === -1) ? await HELPER.encryptRequestData(URL, headers, query) : {body: query, headers}

        return Axios.get(`${API_URL.GETWAY_API}${URL}`,
            { params: encryptedData.body, headers: encryptedData.headers })
    }
}

export default MasterSerive;
